import BoletaConfig from "./BoletaConfig";

export default class BoletaService {
	static setBoleta(value, id) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = BoletaConfig.endpointSetBoletas;
				let response = await BoletaConfig.APIConnector.post(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static updateBoleta(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = BoletaConfig.endpointUpdateBoletas;
				let response = await BoletaConfig.APIConnector.put(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static deleteBoleta(boletaId, boleta) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(boleta);
				let endpoint = BoletaConfig.endpointDeleteBoletas + "/" + boletaId;
				let response = BoletaConfig.APIConnector.delete(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static getBoletaList(idCompany, companyName, month, year, page, size, cuit) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = BoletaConfig.endpoint + "?";
				if (companyName) endpoint += "&companyName=" + companyName;
				if (idCompany) endpoint += "&idCompany=" + idCompany;
				if (month) endpoint += "&month=" + month;
				if (year) endpoint += "&year=" + year;
				if (cuit) endpoint += "&cuit=" + cuit;
				if (page !== null && size !== null)
					endpoint += "&page=" + page + "&size=" + size;
				let response = await BoletaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static generarBoletaPago() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = BoletaConfig.endpointBoletaPago;
				let response = await BoletaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static downloadFile(fileName) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = BoletaConfig.endpointTmp;
				endpoint += `/${fileName}`;
				let response = await BoletaConfig.APIConnector.get(endpoint, {
					downloadFlag: true
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static processFile(file) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = BoletaConfig.endpointProcessFile;
				let response = await BoletaConfig.APIConnector.post(endpoint, {
					body: file,
					multiPartFlag: true
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static printTicket(idPayment, idTicketHeader, onDemand) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					BoletaConfig.endpointPrintTicket +
					"?idPayment=" +
					idPayment +
					"&idTicketHeader=" +
					idTicketHeader +
					"&onDemand=" +
					onDemand;
				let response = await BoletaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static regenerateTicket(idPayment, idExpiredTicketHeader) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					BoletaConfig.endpointRegenerateTicket +
					"?idPayment=" +
					idPayment +
					"&idExpiredTicketHeader=" +
					idExpiredTicketHeader;
				let response = await BoletaConfig.APIConnector.post(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static setAsPaid(idTicketHeader, paidDate) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					BoletaConfig.endpointSetTicketAsPaid +
					"?idTicketHeader=" +
					idTicketHeader +
					"&paidDate=" +
					paidDate;
				let response = await BoletaConfig.APIConnector.post(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static generateTicketOnDemand(ticket) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(ticket);
				let endpoint = BoletaConfig.endpointTicketOnDemand;
				let response = await BoletaConfig.APIConnector.post(endpoint, { body });
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static regenerateTicketOnDemand(
		idPayment,
		idExpiredTicketHeader,
		ticketOnDemand
	) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					BoletaConfig.endpointRegenerateTicketOnDemand +
					"?idPayment=" +
					idPayment +
					"&idExpiredTicketHeader=" +
					idExpiredTicketHeader;
				let body = JSON.stringify(ticketOnDemand);
				let response = await BoletaConfig.APIConnector.post(endpoint, { body });
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static processTxt(txtFile) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = BoletaConfig.endpointProcessTxt;
				let response = await BoletaConfig.APIConnector.post(endpoint, {
					body: txtFile,
					multiPartFlag: true
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getEmpresaMovementList(idEmpresa) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					BoletaConfig.endpointGetMovement + "?idEmpresa=" + idEmpresa;
				let response = await BoletaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/Boleta/BoletaService.js